import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateClientType($companyId: ID!, $attributes: ClientTypeAttributes!) {
    createClientType(companyId: $companyId, attributes: $attributes) {
      clientType {
        id
        ...CreatedClientType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedClientType on ClientType {
    id
    name
    color
  }
`
